import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { dynamicAnimations } from '../../../../animations/animations';
import { Identifier } from '../../../../models/storage.models';
import { DxButtonModule } from 'devextreme-angular';

@Component({
    selector: 'app-help-iframe-modal',
    templateUrl: './help-iframe-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [dynamicAnimations],
    imports: [DxButtonModule]
})
export class HelpIframeModalComponent implements OnInit, OnDestroy {
  @Input() helpContentId = 0;
  @Input() iframeUrl!: string;
  loadedUrl?: SafeResourceUrl;

  @Output()
  closeClick = new EventEmitter<void>();

  destroyed = new Subject<void>();

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.iframeUrl
    );
  }

  ngOnDestroy(): void {
    this.destroyed.next();
  }

  onCloseClick() {
    const frame = window.document.getElementById('helpIframe');
    frame?.parentNode?.removeChild(frame);
    this.closeClick.emit();
  }

  onOpenHelpInNewTab() {
    const lang = localStorage.getItem(Identifier.TYPE_LANGUAGE) || 'en-CA';
    const addatechHelpSystemUrl = 'https://help-addatechqa.clinicmaster.com/';
    const helpSystemSessionUrl = `${addatechHelpSystemUrl}help/content/${this.helpContentId}?lang=${lang}`;
    window.open(helpSystemSessionUrl, '_blank');
  }
}
